import type { AlpineComponent } from 'alpinejs'
import Swiper from 'swiper'
import { Pagination, Navigation, A11y, Mousewheel } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/scrollbar'

export function EntrySlider(): AlpineComponent<{
  swiper: any
  init(): void
  discard(): void
}> {
  return {
    swiper: undefined,

    init() {
      this.swiper = new Swiper(this.$refs.slider, {
        modules: [Pagination, Navigation, A11y, Mousewheel],
        slidesPerView: 1.5,
        spaceBetween: 30,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 20,
        parallax: true,
        grabCursor: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 2.75,
            spaceBetween: 30,
          },
        },
        pagination: {
          el: this.$refs.pagination,
          type: 'progressbar',
        },
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
          disabledClass: 'opacity-50 cursor-not-allowed',
        },
        mousewheel: {
          forceToAxis: true,
        },
        on: {
          slideChange: () => {
            if (this.swiper) {
              this.$refs.counter.textContent = `${this.swiper.realIndex + 1}`
            }
          },
        },
      })
    },

    discard() {
      this.swiper && this.swiper.destroy()
    },
  }
}
